export default "__VITE_ASSET__7$q6mpFY__"